module.exports = __webpack_public_path__ + "img/v1.2.fd4a5cbd.jpg";